exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".multiSelectFooter__wrapper___kAkjx {\n  margin-top: 10px; }\n  .multiSelectFooter__wrapper___kAkjx button {\n    height: 40px;\n    border-radius: 5px;\n    font-size: 15px;\n    font-weight: 600;\n    padding: 0 25px;\n    width: 100%; }\n    .multiSelectFooter__wrapper___kAkjx button + button {\n      margin-left: 15px; }\n  .multiSelectFooter__wrapper___kAkjx .multiSelectFooter__okButton___BoWzP {\n    background: #f94144;\n    color: white; }\n    .multiSelectFooter__wrapper___kAkjx .multiSelectFooter__okButton___BoWzP:hover {\n      color: #fff;\n      background: #f94144; }\n  .multiSelectFooter__wrapper___kAkjx .multiSelectFooter__cancelButton___3cUs9 {\n    border: solid 1px #bfbfbf;\n    color: #000000; }\n    .multiSelectFooter__wrapper___kAkjx .multiSelectFooter__cancelButton___3cUs9:hover {\n      border-color: #f94144; }\n", ""]);

// exports
exports.locals = {
	"wrapper": "multiSelectFooter__wrapper___kAkjx",
	"okButton": "multiSelectFooter__okButton___BoWzP",
	"cancelButton": "multiSelectFooter__cancelButton___3cUs9"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/components/FormControls/MultiSelectModal/styles/multiSelectFooter.scss
// module id = 2122
// module chunks = 6